/* eslint complexity: ["error", 40]*/
/*eslint max-lines-per-function: ["error", 330]*/
import React, { Dispatch, useEffect, useState } from 'react';
import { Button, Form, Modal, OverlayTrigger, Tooltip } from 'react-bootstrap';
import * as Icon from 'react-bootstrap-icons';

import FormRow from '../../../app/components/FormRow';
import DictionarySelector from '../Selects/DictionarySelector';
import { useTranslation } from '../../../common/hooks/useTranslation';
import ValidationAlert from '../../../app/components/ValidationAlert';
import { Option } from '../Selects/Selector';
import {
  GetDictionaryDto,
  GetPaeEstimateItemsDto,
} from '../../../common/pokCore/autogenerated/pokApiClient';
import { OptionWithLang } from '../Selects/Selector';
import { CreatableClearableSelector } from '../Selects/CreatableClearableSelector';
import { usePokCore } from '../../../common/hooks/usePokCore';
import { TooltipKey } from '../../../common/pokCore/tooltip.enum';
import { ImportTeamField } from '../Estimates/ImportTeamField';

interface PaeParameterMapperFormProps {
  paePosition: GetPaeEstimateItemsDto;
  countriesDictionaries?: GetDictionaryDto[];
  pathPhaseDictionaries?: GetDictionaryDto[];
  existingParamLabel: string;
  companyId?: string;
  budgetId?: string;
  pathPhaseEnabled?: boolean;
  handleUpdate?: (
    rowId: string,
    newPurchaseFormDictId: string,
    newPurchaseFormDictValue: string,
    newPurchaseFormDictValueEn: string,
    newCountryDictId: string,
    newCountryDictValue: string,
    newCountryDictValueEn: string,
    newBallDictId: string,
    newBallDictValue: string,
    newBallDictValueEn: string,
    newActionGroup: string,
    newPathPhaseDictId: string,
    newPathPhaseDictValue: string,
    newPathPhaseDictValueEn: string,
    newSpecialistTeamId: string,
    newSpecialistTeamName: string,
  ) => void;
}
export const PaeParameterMapperForm: React.FC<
  PaeParameterMapperFormProps
> = props => {
  const [newPurchaseFormDict, setNewPurchaseFormDict] = useState<
    { id: string | undefined; value?: string; valueEn?: string } | undefined
  >({
    id: props.paePosition.purchaseFormDict?.id,
    value: props.paePosition.purchaseFormDict?.value,
    valueEn: props.paePosition.purchaseFormDict?.valueEn,
  });
  const [newCountryDict, setNewCountryDict] = useState<
    { id: string | undefined; value?: string; valueEn?: string } | undefined
  >({
    id: props.paePosition.countryDict?.id,
    value: props.paePosition.countryDict?.value,
    valueEn: props.paePosition.countryDict?.valueEn,
  });
  const [newBallDict, setNewBallDict] = useState<
    { id: string | undefined; value?: string; valueEn?: string } | undefined
  >({
    id: props.paePosition.ballDict?.id,
    value: props.paePosition.ballDict?.value,
    valueEn: props.paePosition.ballDict?.valueEn,
  });
  const [newActionGroup, setNewActionGroup] = useState<string>(
    props.paePosition.actionGroup || '',
  );
  const [newPathPhaseDict, setNewPathPhaseDict] = useState<
    { id: string | undefined; value?: string; valueEn?: string } | undefined
  >({
    id: props.paePosition.pathPhaseDict?.id,
    value: props.paePosition.pathPhaseDict?.value,
    valueEn: props.paePosition.pathPhaseDict?.valueEn,
  });
  const [newSpecialistTeam, setNewSpecialistTeam] = useState<
    { id: string | undefined; name?: string } | undefined
  >({
    id: props.paePosition.specialistTeamId ?? props.paePosition.deliveryTeamId,
    name:
      props.paePosition.specialistTeamName ??
      props.paePosition.deliveryTeamName,
  });
  const [show, setShow] = useState(false);
  const { t, tk } = useTranslation('projectLng');
  const [showSaveErrors, setShowSaveErrors] = useState(false);
  const pok = usePokCore();

  useEffect(() => {
    setNewPurchaseFormDict(
      props.paePosition.purchaseFormDict
        ? {
            id: props.paePosition.purchaseFormDict?.id,
            value: props.paePosition.purchaseFormDict?.value,
            valueEn: props.paePosition.purchaseFormDict?.valueEn,
          }
        : undefined,
    );
    setNewCountryDict(
      props.paePosition.countryDict
        ? {
            id: props.paePosition.countryDict?.id,
            value: props.paePosition.countryDict?.value,
            valueEn: props.paePosition.countryDict?.valueEn,
          }
        : undefined,
    );
    setNewBallDict(
      props.paePosition.ballDict
        ? {
            id: props.paePosition.ballDict?.id,
            value: props.paePosition.ballDict?.value,
            valueEn: props.paePosition.ballDict?.valueEn,
          }
        : undefined,
    );
    setNewActionGroup(props.paePosition.actionGroup || '');
    setNewPathPhaseDict(
      props.paePosition.pathPhaseDict
        ? {
            id: props.paePosition.pathPhaseDict?.id,
            value: props.paePosition.pathPhaseDict?.value,
            valueEn: props.paePosition.pathPhaseDict?.valueEn,
          }
        : undefined,
    );
    setNewSpecialistTeam(
      props.paePosition.specialistTeamId || props.paePosition.deliveryTeamId
        ? {
            id:
              props.paePosition.specialistTeamId ??
              props.paePosition.deliveryTeamId,
            name:
              props.paePosition.specialistTeamName ??
              props.paePosition.deliveryTeamName,
          }
        : undefined,
    );

    setShowSaveErrors(false);
  }, [props.paePosition, show]);

  const updateParameter = async () => {
    if (props.handleUpdate) {
      props.handleUpdate(
        props.paePosition.idx,
        newPurchaseFormDict?.id || '',
        newPurchaseFormDict?.value || '',
        newPurchaseFormDict?.valueEn || '',
        newCountryDict?.id || '',
        newCountryDict?.value || '',
        newCountryDict?.valueEn || '',
        newBallDict?.id || '',
        newBallDict?.value || '',
        newBallDict?.valueEn || '',
        newActionGroup,
        newPathPhaseDict?.id || '',
        newPathPhaseDict?.value || '',
        newPathPhaseDict?.valueEn || '',
        newSpecialistTeam?.id || '',
        newSpecialistTeam?.name || '',
      );
    }
    setShow(false);
  };

  const handleClose = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    setShow(false);
  };

  const handleClick = async (e: React.MouseEvent) => {
    e.stopPropagation();
    setShow(true);
  };

  const propertyChange = (
    option: OptionWithLang,
    setNew: Dispatch<
      React.SetStateAction<
        | {
            id: string | undefined;
            value?: string;
            valueEn?: string;
          }
        | undefined
      >
    >,
  ) => {
    setNew({
      id: option.value,
      value: option.labelPl,
      valueEn: option.labelEn,
    });
  };

  return (
    <>
      <OverlayTrigger
        overlay={<Tooltip>{t(tk.estimates.changeParam)}</Tooltip>}
        trigger={['hover', 'hover']}
      >
        <Button className="py-0 btn-link btn-transparent" onClick={handleClick}>
          <Icon.ArrowRepeat size={18} className="icon-in-cell" />
        </Button>
      </OverlayTrigger>
      {show && (
        /* eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */
        <div onClick={e => e.stopPropagation()}>
          <Modal
            onHide={() => setShow(false)}
            show={show}
            centered={true}
            keyboard={true}
            backdrop="static"
            size="lg"
          >
            <Modal.Header closeButton>
              <Modal.Title>{t(tk.estimates.chooseParam)}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Form className="d-grid gap-3">
                <FormRow
                  controlId="params"
                  label={t(tk.estimates.positionCountry)}
                >
                  <DictionarySelector
                    dictionary={'Kraj/rynek'}
                    value={newCountryDict?.id || ''}
                    allowableValues={props.countriesDictionaries || []}
                    onChange={option =>
                      propertyChange(option, setNewCountryDict)
                    }
                  />
                </FormRow>
                {props.pathPhaseEnabled &&
                  (props.pathPhaseDictionaries?.length || 0) > 0 && (
                    <FormRow
                      controlId="pathPhase"
                      label={t(tk.estimates.positionPhase)}
                    >
                      <DictionarySelector
                        dictionary={'Faza'}
                        value={newPathPhaseDict?.id || ''}
                        allowableValues={props.pathPhaseDictionaries || []}
                        onChange={option =>
                          propertyChange(option, setNewPathPhaseDict)
                        }
                      />
                    </FormRow>
                  )}
                {props.paePosition.position && (
                  <ImportTeamField
                    positionSpecialistTeams={
                      props.paePosition.position.positionSpecialistTeams
                    }
                    companyId={props.companyId}
                    pathPhaseDictionaries={props.pathPhaseDictionaries}
                    pathPhaseDictionaryId={newPathPhaseDict?.id}
                    teamId={newSpecialistTeam?.id}
                    onTeamChange={setNewSpecialistTeam}
                    onPathPhaseChange={setNewPathPhaseDict}
                  />
                )}
                <FormRow
                  controlId="ball"
                  label={t(tk.estimates.ball)}
                  tooltipKey={TooltipKey.ballTooltip}
                >
                  <DictionarySelector
                    dictionary={'Produkt (Kulka)'}
                    value={newBallDict?.id || ''}
                    onChange={option => propertyChange(option, setNewBallDict)}
                  />
                </FormRow>
                <FormRow controlId="excelName" label={props.existingParamLabel}>
                  <Form.Control
                    type="text"
                    value={props.paePosition.paePurchaseForm || ''}
                    readOnly={true}
                    disabled={true}
                  />
                </FormRow>
                <FormRow
                  controlId="params"
                  label={t(tk.estimates.purchaseForm)}
                >
                  <DictionarySelector
                    dictionary={'Internet - forma zakupu'}
                    value={newPurchaseFormDict?.id || ''}
                    onChange={option =>
                      propertyChange(option, setNewPurchaseFormDict)
                    }
                  />
                </FormRow>
                <FormRow controlId="params" label={t(tk.estimates.actionGroup)}>
                  <CreatableClearableSelector
                    value={newActionGroup ?? ''}
                    valueToShow={true}
                    onChange={option =>
                      setNewActionGroup(
                        option ? (option as Option).label : option,
                      )
                    }
                    provider={(text: string) =>
                      pok.estimateItems.getActionGroupsOptionsByTextByCompanyAndBudget(
                        text,
                        props.companyId || '',
                        props.budgetId || '',
                      )
                    }
                  />
                </FormRow>
              </Form>
              <ValidationAlert
                show={showSaveErrors}
                errors={[t(tk.estimates.selectParameter)]}
                className="m-3"
              />
            </Modal.Body>
            <Modal.Footer>
              <Button variant="outline-secondary" onClick={e => handleClose(e)}>
                {t(tk.button.close)}
              </Button>
              <Button variant="primary" onClick={updateParameter}>
                {t(tk.button.save)}
              </Button>
            </Modal.Footer>
          </Modal>
        </div>
      )}
    </>
  );
};
